import React from 'react'
import {Checkbox} from 'antd'
import QuantityProduct from './QuantityProduct'

class StandardPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5

  onResidenceChange = (e) => {
    this.props.onChange({residence: e.target.checked})
  }

  render() {
    if (this.props.bundleProduct) {
      return super.render()
    }

    return (
      <div>
        {super.render()}

        <div>
          <Checkbox
            checked={this.props.product.residence}
            onChange={this.onResidenceChange}
          >
            Residens
          </Checkbox>
        </div>
      </div>
    )
  }
}

export default StandardPhotoProduct
